import React, { useState } from "react";
import { Row, Col, Alert, Button, Container, Label, Spinner } from "reactstrap";
import { connect } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { forgetUser } from "../../store/actions";
import { saveRecords } from "../../services/api.service";

const ResetPasswordPage = ({ forgetUser, message, forgetError, loading }) => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [isLoading, setIsLoading] = useState(false); // Local loading state for the form

  const handleValidSubmit = async (event, values) => {
    if (values.password !== values.confirmPassword) {
      setAlert({ message: "Passwords do not match", type: "danger" });
      return;
    }

    const payload = {
      token,
      password: values.password,
      confirmPassword: values.confirmPassword,
    };

    setIsLoading(true);

    const response = await saveRecords(payload, "/auth/reset_password");

    setIsLoading(false);

    if (response.code === 1) {
      setAlert({ message: "Password reset successful", type: "success" });
      setTimeout(() => navigate("/"), 3000);
    } else {
      setAlert({
        message: response.message || "Password reset failed",
        type: "danger",
      });
    }
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4}>
              <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={9}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="/" className="logo">
                              <img
                                src="https://www.bermad.com/app/uploads/Bermad-logo-new.png"
                                height="100"
                                alt="logo"
                              />
                            </Link>
                          </div>
                          <h4 className="font-size-18 mt-4">Reset Password</h4>
                        </div>
                        <div className="p-2 mt-5">
                          {alert.message && (
                            <Alert color={alert.type} className="mb-4">
                              {alert.message}
                            </Alert>
                          )}
                          <AvForm
                            className="form-horizontal"
                            onValidSubmit={handleValidSubmit}
                          >
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-lock-line auti-custom-input-icon"></i>
                              <Label htmlFor="password">Password</Label>
                              <AvField
                                name="password"
                                type="password"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Password is required",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Password must be at least 6 characters",
                                  },
                                }}
                                className="form-control"
                                id="password"
                                placeholder="Enter password"
                              />
                            </div>
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-lock-line auti-custom-input-icon"></i>
                              <Label htmlFor="confirmPassword">
                                Confirm Password
                              </Label>
                              <AvField
                                name="confirmPassword"
                                type="password"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "Confirm Password is required",
                                  },
                                  match: {
                                    value: "password",
                                    errorMessage: "Passwords do not match",
                                  },
                                }}
                                className="form-control"
                                id="confirmPassword"
                                placeholder="Confirm password"
                              />
                            </div>
                            <div className="mt-4 text-center">
                              <Button
                                color="primary"
                                className="w-md waves-effect waves-light"
                                type="submit"
                                disabled={isLoading}
                                style={{
                                  background: '#006eb9'
                                }}
                              >
                                {isLoading ? (
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    style={{
                                      marginRight: "10px"
                                    }}
                                  />
                                ) : null}
                                {isLoading ? "Loading..." : "Reset"}
                              </Button>
                            </div>
                          </AvForm>
                        </div>
                        <div className="mt-5 text-center">
                          <p>
                            Don't have an account?{" "}
                            <Link to="/" className="fw-medium text-primary">
                              Log in
                            </Link>
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={8}>
              <div className="bermad-wallpaper">
              </div>
            </Col>
          </Row>
        </Container>
        {/* Inline Spinner for the page */}
        {isLoading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <Spinner color="primary" />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { message, forgetError, loading } = state.Forget;
  return { message, forgetError, loading };
};

export default connect(mapStatetoProps, { forgetUser })(ResetPasswordPage);
